import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Alert, ComboBox } from '@reveni-io/reveni-ui'

import { subscriptionPlans } from '@/common/constants'
import routes from '@/Router/routes.constants'

import { allowedExchangeTypesValues } from './constants'
import { filterAllowedExchangeTypesOptions, getAllowedExchangeTypesValue } from './helpers'
import * as Styles from './styles'

const AllowedExchangeTypesSelector = ({
  allowedPreferences,
  allowExchanges,
  allowInstantExchanges,
  allowsUnifiedFlow,
  setAllowExchanges,
  setAllowInstantExchanges,
  subscriptionPlan,
  disabled,
  allowsInstantTransactions,
}) => {
  const { t } = useTranslation()
  const options = filterAllowedExchangeTypesOptions(allowedPreferences, allowsUnifiedFlow, allowsInstantTransactions)
  const value = getAllowedExchangeTypesValue(allowExchanges, allowInstantExchanges, allowsInstantTransactions)

  const handleChange = e => {
    const value = e.target.value

    if (value === allowedExchangeTypesValues.exchange) {
      setAllowExchanges(true)
      setAllowInstantExchanges(false)
    } else if (value === allowedExchangeTypesValues.instantExchange) {
      setAllowExchanges(false)
      setAllowInstantExchanges(true)
    } else if (value === allowedExchangeTypesValues.exchangeAndInstantExchange) {
      setAllowExchanges(true)
      setAllowInstantExchanges(true)
    }
  }

  if (subscriptionPlan === subscriptionPlans.basic) return null

  return (
    <Styles.Container>
      <ComboBox
        label={t('Modos de cambio disponible')}
        menuItems={options.map(o => ({ ...o, label: t(o.label) }))}
        handleChange={handleChange}
        value={value}
        disabled={disabled}
      />
      {!allowExchanges && (
        <Alert type="info">
          {t(
            'Puedes configurar el mensaje de error que aparecerá para los clientes no admitidos para cambios instantáneos en'
          )}{' '}
          <Link href={routes.configurationPage.copies}>{t('Configuración > Textos')}</Link>
        </Alert>
      )}
    </Styles.Container>
  )
}

export default AllowedExchangeTypesSelector
